import Blue from "~/core";

new Blue({
    name: "EventCalendarWidget",
    selector: ".event-calendar__events-table",
    setup(eventCalendar) {
        // Ensure allEvents is available from window object
        if (!window.allEvents) {
            console.warn('window.allEvents not found, initializing as empty array');
            window.allEvents = [];
        }
        var allEvents = window.allEvents;
        var eventsTable = document.querySelector('.event-calendar__events-table');
        var noEventsMessage = document.querySelector('.event-calendar__no-events-message');
        var currentMonthLabel = document.getElementById('current-month-label');
        var prevMonthBtn = document.getElementById('prev-month-btn');
        var nextMonthBtn = document.getElementById('next-month-btn');
        var currentMonth = getCurrentMonth();
        var currentYear = getCurrentYear();

        var monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];

        function getCurrentMonth() {
            var urlParams = new URLSearchParams(window.location.search);
            var month = parseInt(urlParams.get('month'));
            return isNaN(month) ? new Date().getMonth() + 1 : month;
        }

        function getCurrentYear() {
            var urlParams = new URLSearchParams(window.location.search);
            var year = parseInt(urlParams.get('year'));
            return isNaN(year) ? new Date().getFullYear() : year;
        }

        function eventOccursInMonth(event, month, year) {
            var startDate = new Date(event.EventDate);
            var endDate = new Date(event.EventEndDate);

            return (startDate.getMonth() + 1 === month && startDate.getFullYear() === year) ||
                (endDate.getMonth() + 1 === month && endDate.getFullYear() === year);
        }

        function createEventRow(event) {
            var row = document.createElement('div');
            row.className = 'table-row';
            row.setAttribute('data-event-start', event.EventDate);
            row.setAttribute('data-event-end', event.EventEndDate);
            row.setAttribute('data-event-name', event.EventName);

            var nameCell = document.createElement('div');
            nameCell.className = 'table-cell';
            if (event.HasValidEventName) {
                var link = document.createElement('a');
                link.href = event.WebPageUrlPath;
                link.textContent = event.EventName;
                nameCell.appendChild(link);
            }

            var dateCell = document.createElement('div');
            dateCell.className = 'table-cell';
            if (event.HasValidStartDate) {
                dateCell.textContent = event.EventDateDisplay;
            }

            var typeCell = document.createElement('div');
            typeCell.className = 'table-cell';
            if (event.HasValidEventType) {
                typeCell.textContent = event.EventType;
            }

            row.appendChild(nameCell);
            row.appendChild(dateCell);
            row.appendChild(typeCell);

            return row;
        }

        function filterAndDisplayEvents() {
            // Clear existing events
            eventsTable.innerHTML = '';

            var visibleEvents = allEvents.filter(event =>
                eventOccursInMonth(event, currentMonth, currentYear)
            );

            if (visibleEvents.length > 0) {
                // Sort by event date descending, then by name
                visibleEvents.sort((a, b) => {
                    var dateA = new Date(a.EventDate);
                    var dateB = new Date(b.EventDate);
                    if (dateB.getTime() !== dateA.getTime()) {
                        return dateB.getTime() - dateA.getTime();
                    }
                    return (a.EventName || '').localeCompare(b.EventName || '');
                });
            }

            // Create and append event rows
            visibleEvents.forEach(event => {
                var row = createEventRow(event);
                eventsTable.appendChild(row);
            });

            // Show/hide table and no events message based on whether we have events
            if (visibleEvents.length === 0) {
                eventsTable.style.display = 'none';
                noEventsMessage.textContent = 'No events found for selected month';
                noEventsMessage.style.display = 'block';
            } else {
                eventsTable.style.display = 'block';
                noEventsMessage.style.display = 'none';
            }

            // Update month label
            currentMonthLabel.textContent = `${monthNames[currentMonth - 1]} ${currentYear}`;
        }

        function updateUrl() {
            var url = new URL(window.location);
            url.searchParams.set('month', currentMonth);
            url.searchParams.set('year', currentYear);
            window.history.replaceState({}, '', url);
        }

        function changeMonth(delta) {
            currentMonth += delta;
            if (currentMonth > 12) {
                currentMonth = 1;
                currentYear++;
            } else if (currentMonth < 1) {
                currentMonth = 12;
                currentYear--;
            }
            updateUrl();
            filterAndDisplayEvents();
        }

        prevMonthBtn.addEventListener('click', () => changeMonth(-1));
        nextMonthBtn.addEventListener('click', () => changeMonth(1));

        // Initial filter
        filterAndDisplayEvents();

    }
});